import { render, staticRenderFns } from "./TertiaryDialog.vue?vue&type=template&id=5ffd06ad&scoped=true"
import script from "./TertiaryDialog.vue?vue&type=script&lang=ts"
export * from "./TertiaryDialog.vue?vue&type=script&lang=ts"
import style0 from "./TertiaryDialog.vue?vue&type=style&index=0&id=5ffd06ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd06ad",
  null
  
)

export default component.exports